import './CustomTable.css'
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import edite from "../../assets/edite.svg"
import notfound from "../../assets/7265556.webp"
// import deleteIcon from "../../assets/delete.svg"
import add_icon from '../../assets/add-round-button.svg'
import { useCallback, useEffect, useRef, useState } from "react"
import { Button, Modal } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from 'react-toastify';
import CustomInput from '../CustomInput/CustomInput';
import CustomBtn from '../CustomBtn/CustomBtn';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import CommonModa from '../CommonModa/CommonModal';

function index({ headerIterm, data, secondData, onSubmitAttendance, session_id, sessionID, gradeItems, onDataChanged }) {

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const userinfo = useSelector((state) => state);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [show, setShow] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [inputValue, setInputValue] = useState(""); // State for input
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [selectedItem, setSelectedItem] = useState(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [selectedItemSubject, setSelectedItemSubject] = useState(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [Catitems, setCatItems] = useState([]); // State for array
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [stageLoading, setStageLoading] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [attendance, setAttendance] = useState({}); // Store student attendance state
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [grade_id, setSelectedGradeId] = useState(""); // State to store selected ID
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const fileInputRef = useRef(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showDelete, setShowDelete] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [studentToDelete, setStudentToDelete] = useState(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Show only 4 items on the first page
  const paginatedData = data?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(data?.length / itemsPerPage);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showEdit, setShowEdit] = useState(false);

  const handleShowEdit = (item) => {
    setSelectedItemSubject(item);
    setShowEdit(true);
  };

  const handleCloseEdit = () => {
    setShowEdit(false);
    setSelectedItemSubject(null);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const handleShow = (item) => {
    setSelectedItem(item);
    setInputValue(item.name);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedItem(null);
    setInputValue('');
  };
  let active = 1;
  let items = [];

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();

  for (let number = 1; number <= Math.ceil(data && data.length / 10); number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>,
    );
  }


  const addToArray = (e) => {
    e.preventDefault();
    if (inputValue.trim() !== "") {
      setCatItems([...Catitems, inputValue]); // Add value to array
      setInputValue(""); // Clear input after adding
    }
  };
  const exportSheet = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    try {
      const response = await axios.post("https://nanosoft.technology/taarteb/api/sessions/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

        },
      });
      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });

    } catch (error) {
      toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

    }

  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  // const handleData= useCallback(async() => {
  //   if (data) {
  //     const initialAttendance = {};
  //     data.forEach((student) => {
  //       initialAttendance[student.id] = 1;
  //     });

  //     setAttendance(initialAttendance);
  //   }

  // }, [data]);

  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   useEffect(() => {
  //     handleData()
  //   }, [handleData,]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const handleData = useCallback(() => {
    if (data) {
      const initialAttendance = {};
      data.forEach((student) => {
        initialAttendance[student.id] = 1; // default present
      });

      setAttendance(initialAttendance);
    }
  }, [data]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    handleData();
  }, [handleData]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (Object.keys(attendance).length > 0) {
      onSubmitAttendance({
        session_id: sessionID,
        attendance: Object.keys(attendance).map((id) => ({
          student_id: parseInt(id),
          is_present: attendance[id],
        })),
      });
    }
  }, [attendance, sessionID, onSubmitAttendance]);



  const handleAttendanceChange = (studentId) => {
    setAttendance((prev) => {
      const updatedAttendance = {
        ...prev,
        [studentId]: prev[studentId] === 1 ? 0 : 1, // Toggle between 1 and 0
      };

      // Call the submit function with the latest state
      onSubmitAttendance({
        session_id: sessionID,
        attendance: Object.keys(updatedAttendance).map((id) => ({
          student_id: parseInt(id),
          is_present: updatedAttendance[id],
        })),
      });

      return updatedAttendance;
    });
  };
  const handleCloseDelete = () => {
    setStudentToDelete(null); // مسح البيانات عند الإغلاق
    setShowDelete(false);
  };
  const handleShowDelete = (item) => {
    setStudentToDelete(item); // حفظ بيانات الطالب الذي تم النقر عليه
    setShowDelete(true);
  };
  const handleDeleteConfirmed = async () => {
    if (!studentToDelete) return;

    try {
      const response = await axios.delete(`https://nanosoft.technology/taarteb/api/students/${studentToDelete.id}`, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        },
      });

      // إغلاق المودال ومسح البيانات بعد الحذف الناجح
      handleCloseDelete();
      if (onDataChanged) {
        onDataChanged();
      }
      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
    } catch (error) {
      toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });
    }
  };
  return (
    <div className='mt-5'>
      <ToastContainer />
      {/* <Modal show={showDelete} onHide={handleCloseDelete} centered>
                          <Modal.Body>
                            <div className='text-center'>
                              {currentLocal.home.areyousureyouwantdelet}
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <div className='d-flex justify-content-center w-100'>
                              <Button variant="danger" 
                              onClick={handleDeleteConfirmed}
                              // onClick={async () => {
                              //   const formData = new FormData();
                              //   try {
                              //     const response = await axios.delete(`https://nanosoft.technology/taarteb/api/students/${item.id}`, {
                              //       headers: {
                              //         Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                              //       },
                              //     });
                              //     setShowDelete(false)
                              //     if(onDataChanged){
                              //       onDataChanged()
                              //     }
                              //   } catch (error) {
                              //     toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                              //   }
                              // }}
                              >
                                {currentLocal.home.delete}
                              </Button>

                              <Button variant="secondary" onClick={handleCloseDelete} className='mx-3'>
                                {currentLocal.home.close}

                              </Button>
                            </div>
                          </Modal.Footer>
                        </Modal> */}
      <Modal show={showDelete} onHide={handleCloseDelete} centered>
        <Modal.Body>
          <div className='text-center'>
            {currentLocal.home.areyousureyouwantdelet}
            {/* عرض اسم الطالب للتأكيد */}
            {studentToDelete && <div>**{studentToDelete.name}**</div>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center w-100'>
            <Button variant="danger" onClick={handleDeleteConfirmed}>
              {currentLocal.home.delete}
            </Button>

            <Button variant="secondary" onClick={handleCloseDelete} className='mx-3'>
              {currentLocal.home.close}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {selectedItemSubject &&
        <CommonModa
          showEdit={showEdit}
          handleClose={handleCloseEdit}
          state={currentLocal.home.edit}
          item={selectedItemSubject}
          onDataChanged={onDataChanged}

        />
      }
      {data && data.length !== 0 ?
        <>
          <Table striped responsive>
            <thead>
              <tr>
                {headerIterm && headerIterm.map((item, index) => {
                  return (
                    <th key={index}>{item}</th>

                  )

                })}
              </tr>
            </thead>
            <tbody>
              {paginatedData && paginatedData.map((item, index) => {

                return (
                  <>
                    {location.pathname.includes('Schools') &&

                      <tr key={index}>
                        <Modal show={showDelete} onHide={handleCloseDelete} centered>
                          <Modal.Body>
                            <div className='text-center'>
                              {currentLocal.home.areyousureyouwantdelet}
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <div className='d-flex justify-content-center w-100'>
                              <Button variant="danger" onClick={async () => {
                                const formData = new FormData();
                                try {
                                  const response = await axios.delete(`https://nanosoft.technology/taarteb/api/schools/${item.id}`, {
                                    headers: {
                                      Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                                    },
                                  });
                                  setShowDelete(false)
                                  if (onDataChanged) {
                                    onDataChanged()
                                  }
                                } catch (error) {
                                  toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                                }
                              }}>
                                {currentLocal.home.delete}
                              </Button>

                              <Button variant="secondary" onClick={handleCloseDelete} className='mx-3'>
                                {currentLocal.home.close}

                              </Button>
                            </div>
                          </Modal.Footer>
                        </Modal>
                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.manager.email}</td>
                        <td>{item.manager.phone}</td>


                        <td>
                          <div onClick={() => {
                            navigate(`/dashboard/admin/Classes/${item.id}`, { state: { teacherData: item } });

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                        <td>
                          <div onClick={() => {
                            navigate(`/dashboard/admin/Subjects/${item.id}`, { state: { teacherData: item } });

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                        <td>
                          <div onClick={() => {
                            navigate(`/dashboard/admin/Classes/${item.id}`, { state: { teacherData: item } });

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                        <td>
                          <div onClick={() => {
                            navigate(`/dashboard/admin/Students/${item.id}`, { state: { teacherData: item } });

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                        <td>
                          <div onClick={() => {
                            navigate(`/dashboard/admin/teachers/${item.id}`, { state: { teacherData: item } });

                          }} style={{ cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </div>
                        </td>
                        <td>
                          <div onClick={handleShowDelete} style={{ cursor: "pointer", display: "flex ", justifyContent: "center", alignItems: "center", color: "red" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </div>
                        </td>
                      </tr>

                    }

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {

                return (
                  <>
                    {location.pathname.includes('Subjects') &&
                      <tr key={index}>

                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.grade_category}</td>
                        <td>{item.grade}</td>
                        <td>{item.semester}</td>
                        <td >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: "pointer" }} onClick={() => handleShowEdit(item)}
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg>
                        </td>

                      </tr>




                    }

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('teachers') &&
                      <tr key={index}>

                        <td>{item.id}</td>

                        <td>{item.name}</td>
                        <td>

                          {item.subjects.map((subItem) => {
                            return (
                              <p>{subItem?.name}</p>
                            )
                          })}</td>
                        {/* <td>{item.grade}</td> */}
                        <td>{item.email}</td>
                        <td>{item.gender === "m" ? "Male" : "Female"}</td>

                      </tr>




                    }

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('mark-attendance') &&
                      <tr key={index}>
                        <td>{item.identity_number}</td>
                        <td>{item.name}</td>


                        <td>

                          <input
                            type="checkbox"
                            value={attendance[item.id]} // optional if needed
                            checked={attendance[item.id] === 1}
                            onChange={() => handleAttendanceChange(item.id)}
                          />
                        </td>

                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('lateattendance') &&
                      <tr key={index}>
                        <td>{item.identity_number}</td>
                        <td>{item.name}</td>


                        <td>

                          <input
                            type="checkbox"
                            value={attendance[item.id]} // optional if needed
                            checked={attendance[item.id] === 0}
                            onChange={() => handleAttendanceChange(item.id)}
                          />
                        </td>

                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('attendance-history') &&
                      <tr key={index}>
                        <td>{item.student}</td>
                        <td>{item.teacher}</td>
                        <td>{item.subject}</td>



                        <td>
                          {item.is_present === 1 ?
                            <div className='px-3 py-2 bg-success d-flex text-white status_box'>
                              {currentLocal.home.Attended}
                            </div>
                            :
                            <div className='px-3 py-2 bg-danger d-flex text-white status_box'>
                              {currentLocal.home.Absent}

                            </div>
                          }
                        </td>

                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {

                return (
                  <>
                    {location.pathname.includes('Classes') &&

                      <tr key={index}>
                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.grade_category}</td>

                        <td>{item.grade}</td>

                        <td>{item.max_students}</td>
                        <td>{item.session_number}</td>
                        {!location.pathname.includes('admin') &&
                          <td>
                            <>
                              <div className='d-flex justify-content-center' style={{ cursor: "pointer" }} onClick={() => navigate(`/dashboard/time-table/${item.id}`)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                              </div>

                              <input
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRef}
                                onChange={exportSheet}
                                style={{ display: "none" }}
                              />
                            </>
                          </td>
                        }
                        {!location.pathname.includes('admin') &&
                          <td>
                            <>
                              <div className='d-flex justify-content-center'>
                                <td >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: "pointer" }} onClick={() => handleShowEdit(item)}
                                  >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                  </svg>
                                </td>
                              </div>

                              <input
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRef}
                                onChange={exportSheet}
                                style={{ display: "none" }}
                              />
                            </>
                          </td>
                        }
                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('Students') &&
                      <tr key={index}>

                        <td>{item.identity_number}</td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        {item?.parent_phone != "undefined" ? <td>{item?.parent_phone}</td> : <td>---</td>}
                        {item?.class != null ? <td>{item?.class}</td> : <td>---</td>}
                        <td>{item.grade_category}</td>

                        <td>{item.grade}</td>
                        <td>{item.gender}</td>
                        <td className='d-flex align-items-center'>
                          <div onClick={() => handleShowDelete(item)} style={{ cursor: "pointer", display: "flex ", justifyContent: "center", alignItems: "center", color: "red" }} className='mx-2'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </div>
                          <div
                          //  onClick={() => handleShowDelete(item)}
                           style={{ cursor: "pointer", display: "flex ", justifyContent: "center", alignItems: "center", color: "red" }} className='mx-2' onClick={() => {
                            navigate(`/dashboard/students/edit/${item?.id}`)
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: "pointer" }}
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </div>
                        </td>
                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('/structure') &&
                      <tr key={index}>

                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        {item.category &&
                          <td>{item.category}</td>
                        }
                        {!location.pathname.includes('/admin/structure') &&
                          <td >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: "pointer" }} onClick={() => handleShow(item)}
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </td>
                        }
                        {location.pathname.includes('/admin/structure') &&
                          <>

                            <td>
                              <div onClick={() => {
                                //  navigate('/dashboard/Teachers',) 
                                navigate(`/dashboard/admin/Classes/${item.id}`, { state: { teacherData: item } });

                              }} style={{ cursor: "pointer" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                              </div>
                            </td>
                            <td>
                              <div onClick={() => {
                                navigate(`/dashboard/admin/teachers/${item.id}`, { state: { teacherData: item } });

                              }} style={{ cursor: "pointer" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                              </div>
                            </td>

                          </>

                        }


                      </tr>}

                  </>


                )
              })}
              {selectedItem && (
                <Modal show={show} onHide={handleClose} centered>
                  <Modal.Body>
                    <form className='mt-4'>
                      {location.pathname.includes('grades') &&
                        <div>

                          <label>{currentLocal.home.stageName}</label>
                          <div className='w-100 position-relative'>
                            <Select
                              value={grade_id}
                              onChange={(selectedOption) => setSelectedGradeId(selectedOption)}
                              options={gradeItems}
                              placeholder={currentLocal.home.SelectStage}

                            />
                          </div>
                        </div>
                      }
                      <label className="text-mutedx">{location.pathname.includes("stages") ? currentLocal.home.stageName : currentLocal.home.gradeName}</label>

                      <CustomInput
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                    </form>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className='d-flex justify-content-center w-100'>
                      <Button variant="primary" onClick={async (e) => {
                        e.preventDefault();

                        if (location.pathname.includes('grades')) {

                          if (grade_id.value == undefined) {
                            toast.error(currentLocal.home.chooseStageFirst, { position: "bottom-right", autoClose: 3000 });

                          } else {
                            console.log(grade_id?.value);
                            
                            try {
                              const response = await axios.put(`https://nanosoft.technology/taarteb/api/grades/${selectedItem.id}`, {
                                name                                  : inputValue,
                                grade_category_id:grade_id?.value?grade_id?.value: grade_id.id
                              }, {
                                headers: {
                                  Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                                },
                              });
                              setShow(false);
                              if (onDataChanged) {
                                onDataChanged()
                              }
                            } catch (error) {
                              toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                            }
                          }


                        } else {
                          try {
                            const response = await axios.put(`https://nanosoft.technology/taarteb/api/grade-categories/${selectedItem && selectedItem.id}`, {
                              name
                                : inputValue
                            }, {
                              headers: {
                                Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                              },
                            });
                            setShow(false)
                          } catch (error) {
                            toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                          }
                        }

                      }} className='mx-3'>
                        {currentLocal.home.edit}
                      </Button>
                      <Button variant="secondary" onClick={handleClose}>
                        {currentLocal.home.close}
                      </Button>
                    </div>
                  </Modal.Footer>
                </Modal>
              )}

              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('/dashboard/Teachers') &&
                      <tr key={index}>
                        <Modal show={showDelete} onHide={handleCloseDelete} centered>
                          <Modal.Body>
                            <div className='text-center'>
                              {currentLocal.home.areyousureyouwantdelet}
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <div className='d-flex justify-content-center w-100'>
                              <Button variant="danger" onClick={async () => {
                                const formData = new FormData();
                                try {
                                  const response = await axios.delete(`https://nanosoft.technology/taarteb/api/teachers/${item.id}`, {
                                    headers: {
                                      Authorization: `Bearer ${userinfo.auth.userArray.access_token}`

                                    },
                                  });
                                  setShowDelete(false)
                                  if (onDataChanged) {
                                    onDataChanged()
                                  }
                                } catch (error) {
                                  toast.error(Object.values(error.response.data.errors.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                                }
                              }}>
                                {currentLocal.home.delete}
                              </Button>

                              <Button variant="secondary" onClick={handleCloseDelete} className='mx-3'>
                                {currentLocal.home.close}

                              </Button>
                            </div>
                          </Modal.Footer>
                        </Modal>
                        <td>{item.id}</td>

                        <td>{item.name}</td>
                        <td>
                          {item.subjects.map((subjItem) => {
                            return (
                              <div className='mx-3'>
                                {subjItem.name}</div>
                            )
                          })}
                        </td>
                        <td>{item.email}</td>
                        <td>{item.gender === "f" ? "Female" : "Male"}</td>
                        <td>
                          <div onClick={handleShowDelete} style={{ cursor: "pointer", display: "flex ", justifyContent: "center", alignItems: "center", color: "red" }} className='mx-2'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </div>
                        </td>

                      </tr>}

                  </>


                )
              })}
              {paginatedData && paginatedData.map((item, index) => {
                return (
                  <>
                    {location.pathname.includes('/school-structure') &&
                      <tr key={index}>
                        <Modal show={show} onHide={handleClose} centered>
                          <Modal.Header closeButton>
                            <Modal.Title>
                              Add Stages
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <form className='mt-4'>
                              <label>Stage Name *    </label>
                              <div className='w-100 position-relative'>
                                <CustomInput
                                  value={inputValue}
                                  onChange={(e) => { setInputValue(e.target.value) }}

                                />
                                <div className='add_icon_container w-25' onClick={addToArray}>
                                  <img src={add_icon} alt='' className='w-25' />

                                </div>
                              </div>
                              <ul className='d-flex'>
                                {Catitems.length !== 0 &&
                                  <li className='fw-bold'>Grades :</li>
                                }
                                {Catitems.map((item, index) => (
                                  <li key={index} className='mx-2'>{item}</li> // Display added values
                                ))}
                              </ul>

                            </form>


                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                              Close
                            </Button>
                            <CustomBtn text={stageLoading ? "Logging in..." : "Add"} disabled={stageLoading} clickingFunction={async (e) => {
                              e.preventDefault();
                              setStageLoading(true);

                              try {
                                const response = await axios.post('https://nanosoft.technology/taarteb/api/grades', {
                                  "grades": [{ "name": "Grade 1" }, { "name": "Grade 2" }],
                                  grade_category_id: item.id
                                }, {
                                  headers: {
                                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                                  }
                                });

                                toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
                                setShow(false)
                              } catch (error) {
                                console.error("Error:", error.response?.data || error.message);
                                //             // alert("Failed to add Stage!");

                              } finally {
                                setStageLoading(false);
                              }
                            }} />

                          </Modal.Footer>
                        </Modal>
                        <td className='pe-5'>{item.name}</td>
                        <td className='w-50'>
                          {secondData ? secondData.map((secondItem) => {
                            return (
                              <span className='mx-3'>{secondItem.name}</span>
                            )
                          }) :
                            <span className='w-50'></span>

                          }

                        </td>


                        <td className='d-flex align-items-center'>
                          <div className='mx-3'>
                            <Link>
                              <img src={edite} alt='' />
                            </Link>
                          </div>
                          <div className='w-25'>
                            <div className='w-25 cursor-pointer' onClick={handleShow}>
                              <img src={add_icon} alt='' className='add_icon w-100' />
                            </div>
                          </div>
                        </td>

                      </tr>}

                  </>


                )
              })}







            </tbody>
          </Table>

          <div className='d-flex justify-content-center w-100 mt-5'>
            <Pagination style={{ direction: "ltr" }}>
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>

        </>
        :
        <div className='empty_container  d-flex justify-content-center align-items-center'>
          <div className='w-50'>
            <img src={notfound} alt='' className='w-50' />

          </div>
        </div>


      }


    </div>
  )
}

export default index
